exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status[data-v-f4a562ce] {\n  text-align: center;\n  width: 100%;\n}\n.status img[data-v-f4a562ce] {\n  width: 2.16rem;\n  height: 2.106667rem;\n  margin-top: 1.88rem;\n}\n.status .title[data-v-f4a562ce] {\n  font-size: 0.48rem;\n  font-family: PingFangSC-Medium, PingFang SC;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.666667rem;\n  margin-top: 0.293333rem;\n}\n.status .desc[data-v-f4a562ce] {\n  font-size: 0.373333rem;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.533333rem;\n  margin-top: 0.266667rem;\n  margin-bottom: 1.066667rem;\n}", ""]);

// exports
